import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import isString from 'lodash/isString';
import useSWR, { cache } from 'swr';
import { AuthError, UnauthorizedError } from '@signal/utils/errors';
export var STANDARD_TRANSITION_TIMEOUT = 5000;
export var FETCH_TIMEOUT = 30000;

function fetchData(_x) {
  return _fetchData.apply(this, arguments);
}

function _fetchData() {
  _fetchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args) {
    var options,
        controller,
        timeoutId,
        response,
        _response,
        status,
        statusText,
        errorText,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            controller = new AbortController();
            timeoutId = setTimeout(function () {
              controller.abort();
            }, FETCH_TIMEOUT);
            _context3.prev = 3;
            _context3.next = 6;
            return fetch(args, _objectSpread(_objectSpread({}, options), {}, {
              credentials: 'include',
              mode: 'cors',
              signal: controller.signal
            }));

          case 6:
            response = _context3.sent;
            _context3.next = 14;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);

            if (!(_context3.t0 instanceof DOMException)) {
              _context3.next = 13;
              break;
            }

            throw new Error('The operation timed out.  Please try again.');

          case 13:
            throw _context3.t0;

          case 14:
            _context3.prev = 14;
            clearTimeout(timeoutId);
            return _context3.finish(14);

          case 17:
            _context3.prev = 17;
            _context3.next = 20;
            return response.json();

          case 20:
            return _context3.abrupt("return", _context3.sent);

          case 23:
            _context3.prev = 23;
            _context3.t1 = _context3["catch"](17);

            if (response.ok) {
              _context3.next = 34;
              break;
            }

            _response = response, status = _response.status, statusText = _response.statusText;
            _context3.t2 = status;
            _context3.next = _context3.t2 === 401 ? 30 : _context3.t2 === 403 ? 31 : 32;
            break;

          case 30:
            throw new AuthError();

          case 31:
            throw new UnauthorizedError(statusText);

          case 32:
            errorText = "".concat(statusText ? statusText : status, " error");
            throw new Error(errorText);

          case 34:
            throw _context3.t1;

          case 35:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 9, 14, 17], [17, 23]]);
  }));
  return _fetchData.apply(this, arguments);
}

export default function getData() {
  return _getData.apply(this, arguments);
}

function _getData() {
  _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetchData.apply(void 0, _args4);

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getData.apply(this, arguments);
}

export function postData(_x2, _x3) {
  return _postData.apply(this, arguments);
}
/**
 * call this to generate a cache key for use with SWR
 * @param {String} urlOrCacheKey - the URL part of the cache key, or an already built cache key (no-op)
 * @param {Object or String} body - POST data object to be part of the cache key, optional
 * @return {String} - a cache key to use with SWR
 */

function _postData() {
  _postData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, body) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fetchData(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: body
            });

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _postData.apply(this, arguments);
}

export function makeSWRCacheKey(urlOrCacheKey) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!urlOrCacheKey.endsWith('/')) {
    urlOrCacheKey += '/';
  }

  var serializedBody = isString(body) ? body : JSON.stringify(body);
  return urlOrCacheKey + serializedBody;
}
/**
 * call this to cache bust the given URL (including any varying post parameters)
 * @param {String} url - the url to remove cache keys for
 */

export function cacheBustURL(url) {
  var cacheKey = makeSWRCacheKey(url);
  cache.keys().forEach(function (keyCur) {
    // if you use a cache key for a POST with no body specified, all cache keys related to that URL will be marked stale
    if (keyCur.startsWith(cacheKey)) {
      cache.delete(keyCur);
    }
  });
}
/**
 * call this to change the content of the cache at a given URL
 * @param {String} urlOrCacheKey - the URL part of the cache key, or an already built cache key (no-op)
 * @param {Object or String} body - POST data object to be part of the cache key, optional
 * @param {Object} data - the data to replace in the cache
 */

export function replaceCacheURL(urlOrCacheKey) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var cacheKey = makeSWRCacheKey(urlOrCacheKey, body);
  cache.set(cacheKey, data);
}
/**
 * this is a wrapper function around SWR designed to be used for cacheable POSTs for data fetching
 * @param {String} url - the URL to POST to
 * @param {Object} body - POST data
 * @param {String} context - the context of this POST, for debugging purposes
 * @param {Function} transformFunc - an optional function to transform the resulting data
 * @return {Object} - the data from the SWR response object
 */

export function usePost(url, body, context, transformFunc) {
  var serializedBody = JSON.stringify(body);
  var cacheKey = makeSWRCacheKey(url, serializedBody);

  var _useSWR = useSWR(cacheKey, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var ret;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!cache.get(cacheKey)) {
              console.log('[swr] usePost not cached', context, url, body);
            }

            _context.t0 = cache.get(cacheKey);

            if (_context.t0) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return postData(url, serializedBody);

          case 5:
            _context.t0 = _context.sent;

          case 6:
            ret = _context.t0;
            return _context.abrupt("return", transformFunc ? transformFunc(ret) : ret);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))),
      data = _useSWR.data;

  return data;
}
/**
 * this is a wrapper function around SWR designed to be used for cacheable GETs for data fetching
 * @param {String} urlOrCacheKey - the URL or cache key to GET
 * @param {String} context - the context of this GET, for debugging purposes
 * @param {Function} fetcher - a fetcher function to fetch data that returns a Promise, as supported by useSWR
 * @param {Function} transformFunc - an optional function to transform the resulting data
 * @return {Object} - the data from the SWR response object
 */

export function useGet(urlOrCacheKey, context) {
  var fetcher = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getData;
  var transformFunc = arguments.length > 3 ? arguments[3] : undefined;
  var cacheKey = makeSWRCacheKey(urlOrCacheKey);

  var _useSWR2 = useSWR(cacheKey, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var ret;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!cache.get(cacheKey)) {
              console.log('[swr] useGet not cached', context, urlOrCacheKey);
            }

            _context2.t0 = cache.get(cacheKey);

            if (_context2.t0) {
              _context2.next = 6;
              break;
            }

            _context2.next = 5;
            return fetcher(urlOrCacheKey);

          case 5:
            _context2.t0 = _context2.sent;

          case 6:
            ret = _context2.t0;
            return _context2.abrupt("return", transformFunc ? transformFunc(ret) : ret);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }))),
      data = _useSWR2.data;

  return data;
}
/**
 * this is a function to get a URL and insert the result in the cache.  This can be used to "prime" data to avoid
 * loading states in SWR
 * @param {String} url - the URL to GET
 * @param {String} context - the context of the GET, for debugging purposes
 * @param {Boolean} force - whether to force the re-cache even if data exists
 * @return {Object} - the data from the GET
 */

export function getAndCache(_x4, _x5) {
  return _getAndCache.apply(this, arguments);
}
/**
 * this is a function to get a URL and insert the result in the cache.  This can be used to "prime" data to avoid
 * loading states in SWR
 * @param {String} url - the URL to POST to
 * @param {Object} body - the POST body
 * @param {String} context - the context of the POST, for debugging purposes
 * @param {Boolean} force - whether to force the re-cache even if data exists
 * @return {Object} - the data from the POST
 */

function _getAndCache() {
  _getAndCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url, context) {
    var force,
        cacheKey,
        data,
        cacheText,
        forceExtra,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            force = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : false;
            cacheKey = makeSWRCacheKey(url);
            data = cache.get(cacheKey);

            if (!(!data || force)) {
              _context6.next = 17;
              break;
            }

            cacheText = "[swr] getAndCache ".concat(force ? 'forced' : 'not cached');
            forceExtra = force ? "was cached: ".concat(!!data) : '';
            console.log(cacheText, context, url, forceExtra);
            _context6.prev = 7;
            _context6.next = 10;
            return getData(url);

          case 10:
            data = _context6.sent;
            cache.set(cacheKey, data);
            _context6.next = 17;
            break;

          case 14:
            _context6.prev = 14;
            _context6.t0 = _context6["catch"](7); // silent failure if we can't GET when trying to cache.  Return the error if someone is inspecting the response

            data = _context6.t0;

          case 17:
            return _context6.abrupt("return", data);

          case 18:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[7, 14]]);
  }));
  return _getAndCache.apply(this, arguments);
}

export function postAndCache(_x6, _x7, _x8) {
  return _postAndCache.apply(this, arguments);
}

function _postAndCache() {
  _postAndCache = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(url, body, context) {
    var force,
        serializedBody,
        cacheKey,
        data,
        cacheText,
        forceExtra,
        _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            force = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : false;
            serializedBody = JSON.stringify(body);
            cacheKey = makeSWRCacheKey(url, serializedBody);
            data = cache.get(cacheKey);

            if (!(!data || force)) {
              _context7.next = 19;
              break;
            }

            cacheText = "[swr] postAndCache ".concat(force ? 'forced' : 'not cached');
            forceExtra = force ? "was cached: ".concat(!!data) : '';
            console.log(cacheText, context, url, body, forceExtra);
            _context7.prev = 8;
            _context7.next = 11;
            return postData(url, serializedBody);

          case 11:
            data = _context7.sent;

            if (force) {
              // if we ae forcing a cache replacement, then cache bust anything that was similar (different post params) too
              // this was fix for MRD-1661
              cacheBustURL(url);
            }

            cache.set(cacheKey, data);
            _context7.next = 19;
            break;

          case 16:
            _context7.prev = 16;
            _context7.t0 = _context7["catch"](8); // silent failure if we can't POST when trying to cache.  Return the error if someone is inspecting the response

            data = _context7.t0;

          case 19:
            return _context7.abrupt("return", data);

          case 20:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[8, 16]]);
  }));
  return _postAndCache.apply(this, arguments);
}